import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import './Button.css';
import './Navbar.css';

function Navbar() {
  const [click, setClick] = useState(false);

  const handleClick = () => setClick(!click);

  const closeMobileMenu = () => {
    setClick(false);
    window.scrollTo(0, 0);
  };

  return (
    <>
      <nav className="navbar">
        <div className="navbar-container">
          <NavLink to="/home" className="navbar-logo" end onClick={closeMobileMenu}>
            <img
              src="./Images/willtowealth.png"
              alt="Will to Wealth logo"
              className="navbar-logo-img"
            />
            <span className="navbar-logo-text">Will to Wealth</span>
          </NavLink>

          <div className="menu-icon" onClick={handleClick}>
            <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
          </div>

          <ul className={click ? 'nav-menu active' : 'nav-menu'}>
            <li className="nav-item">
              <NavLink to="/home" className="nav-links" onClick={closeMobileMenu}>
                HOME
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/consultation" className="nav-links" onClick={closeMobileMenu}>
                CONSULTATION
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/blog" className="nav-links" onClick={closeMobileMenu}>
                BLOG
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/about-us" className="nav-links" onClick={closeMobileMenu}>
                ABOUT US
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/services" className="nav-links" onClick={closeMobileMenu}>
                OUR SERVICES
              </NavLink>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
}

export default Navbar;